import React from 'react';
import { FadeIn } from './FadeIn';
import { CalendarCheck, Clock, Laptop, ListChecks, Sparkles, Zap } from 'lucide-react';
const items = [{
  icon: CalendarCheck,
  text: 'Actualizado para Amazon 2026'
}, {
  icon: ListChecks,
  text: 'Explicado paso a paso'
}, {
  icon: Sparkles,
  text: 'Ideal para principiantes'
}, {
  icon: Clock,
  text: 'Aprende a tu propio ritmo'
}, {
  icon: Zap,
  text: 'Acceso inmediato después del pago'
}, {
  icon: Laptop,
  text: 'Compatible con computadora, tablet y celular'
}];
export function ConfianzaSistema() {
  return <section className="bg-brand-white px-5 py-20 sm:px-6 md:py-24" data-id="element-206" data-mp="2qi1jdzzxd97k">
      <div className="mx-auto max-w-5xl" data-id="element-207" data-mp="2ulgd1tgsdo3h">
        <FadeIn data-id="element-208" data-mp="2umj4c2i0tsjx">
          <div className="mx-auto mb-12 max-w-2xl text-center" data-id="element-209" data-mp="2uiv8uxt0mw2k">
            <p className="mb-3 text-xs font-bold uppercase tracking-[0.2em] text-brand-gold" data-id="element-210" data-mp="5suaxcflli0i">
              Confianza desde el inicio
            </p>
            <h2 className="font-serif text-3xl font-bold leading-tight tracking-tight text-brand-green sm:text-4xl" data-id="element-211" data-mp="sv3yudipbdan">
              Diseñado para ayudarte a empezar correctamente
            </h2>
          </div>
        </FadeIn>

        <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-212" data-mp="iweod5t4wv4f">
          {items.map((item, index) => {
          const Icon = item.icon;
          return <FadeIn key={item.text} delay={0.05 * index} data-id="element-213" data-mp="9w88jd9yrj23" data-mpi={index}>
                <li className="flex h-full items-center gap-4 rounded-2xl border border-brand-text/10 bg-white px-5 py-5 shadow-[0_10px_30px_-24px_rgba(26,26,26,0.35)]" data-id="element-214" data-mp="9ykwc72eknn2">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-green/8" data-id="element-215" data-mp="7ghr8gn34sr">
                    <Icon className="h-5 w-5 text-brand-green" data-id="element-216" data-mp="3ret1nv8wpwcd" />
                  </span>
                  <span className="text-sm font-semibold leading-snug text-brand-text/80" data-id="element-217" data-mp="3nav1ribrchi9">
                    {item.text}
                  </span>
                </li>
              </FadeIn>;
        })}
        </ul>
      </div>
    </section>;
}